import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import { ToastContainer } from 'react-toastify';

import { CustomErrorBoundary } from './components/error-boundary';
import { AuthContextProvider } from './providers/auth/auth-service';
import { DashboardProvider } from './providers/dashboard-provider';
import { GlobalProvider } from './providers/global-provider';
import { PricerHandoffProvider } from './providers/pricer-handoff/pricer-handoff-provider';
import { darkTheme } from './theme/theme';
import Background from './widgets/immersive/background/background';
import GroupedRoutes from './routes';
import 'react-toastify/dist/ReactToastify.css';
import pkg from '../package.json';
import { useSessionTracker } from './hooks/use-session-tracker';
import { useAuth0 } from '@auth0/auth0-react';

export default function App() {
  const theme = React.useMemo(() => darkTheme, []);

  React.useEffect(() => {
    document.title = 'Immersive Finance';
  }, []);

  const { user } = useAuth0();

  useSessionTracker(user?.email);

  console.log('version', pkg.version);

  return (
    <CustomErrorBoundary>
      <ThemeProvider theme={theme}>
        <Background />
        <CssBaseline />
        <AuthContextProvider>
          <GlobalProvider>
            <DashboardProvider>
              <PricerHandoffProvider>
                <ToastContainer />
                <GroupedRoutes />
              </PricerHandoffProvider>
            </DashboardProvider>
          </GlobalProvider>
        </AuthContextProvider>
      </ThemeProvider>
    </CustomErrorBoundary>
  );
}
